import Vue from 'vue';
import * as types from '../mutation-types';
import config from '@/config';

const state = {
  accessToken: undefined,
  isOnline: true,
  cloudStatus: {
    status_ws: true, // false - down, true - up
    status_vpn: 1, // 0 - down, 1 - up
    status_coms: 1, // 0 - down, 1 - up
    status_plc: 1, // 0 - down, 1 - up
    status_update: 0, // 0 - not updating, 1 - updating
  },
  service: {
    servicesSelectionEnabled: false,
  },
  spaceplan: {
    isEditModeEnabled: false,
    currentServiceCtxMenu: undefined,
  },
  scene: {
    isEditModeEnabled: false,
  },
  project: {
    isEditModeEnabled: false,
  },
  logging: {
    selectedDtRange: {
      from: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
      to: new Date(),
    },
  },
  menuExpandedItems: {},
  navigationSettings: {
    serviceGroupTileClickNavigatesToNextLevel: true,
    serviceTileClickNavigatesToNextLevel: false,
  },
};

const mutations = {
  [types.SET_ACCESS_TOKEN]: (state, accessToken) => {
    state.accessToken = accessToken;
  },
  [types.SET_ONLINE_STATUS]: (state, isOnline) => {
    state.isOnline = isOnline;
  },
  [types.SET_CLOUD_STATUS]: (state, cloudStatus) => {
    state.cloudStatus = { ...state.cloudStatus, ...cloudStatus };
  },
  [types.TOGGLE_SERVICES_SELECTION]: (state) => {
    state.service.servicesSelectionEnabled = !state.service.servicesSelectionEnabled;
  },
  [types.DISABLE_SERVICES_SELECTION]: (state) => {
    state.service.servicesSelectionEnabled = false;
  },
  [types.SET_APPLICATION_STATE]: (state, { section, setting }) => {
    const prevSetting = state[section];
    state[section] = {
      ...prevSetting,
      ...setting,
    };
  },
  [types.ADD_EXPANDED_ITEM_INTO_MENU]: (state, item) => {
    state.menuExpandedItems[item.id] = true;
  },
  [types.REMOVE_EXPANDED_ITEM_FROM_MENU]: (state, item) => {
    delete state.menuExpandedItems[item.id];
  },
  [types.UPDATE_NAVIGATION_SETTINGS]: (state, settings) => {
    state.navigationSettings = { ...state.navigationSettings, ...settings };
  },
};

const getters = {
  getState: state => section => state[section],
  isConnectionOk: (state, getters) => {
    if (config.ICOOL.FORCE_CONNECTION_OK) {
      return true;
    }
    return getters.isPLCok
    && getters.isCOMSok
    && getters.isVPNok
    && getters.isWSok
    && state.isOnline;
  },
  isPLCok: state => state.cloudStatus.status_plc === 1,
  isVPNok: state => state.cloudStatus.status_vpn === 1,
  isCOMSok: state => state.cloudStatus.status_coms === 1,
  isWSok: state => state.cloudStatus.status_ws === true || !config.ICOOL.ENABLE_WEBSOCKETS,
};

const actions = {
  setAccessToken({ commit }, accessToken) {
    commit(types.SET_ACCESS_TOKEN, accessToken);
  },
  toggleServicesSelection({ commit }) {
    commit(types.TOGGLE_SERVICES_SELECTION);
  },
  disableServicesSelection({ commit }) {
    commit(types.DISABLE_SERVICES_SELECTION);
  },
  setState({ commit }, { section, setting }) {
    commit(types.SET_APPLICATION_STATE, { section, setting });
  },
  SOCKET_CLOUD_STATUS_UPDATED({ commit, getters }, msg) {
    const data = JSON.parse(msg);
    Vue.$log.debug(data);
    commit(types.SET_CLOUD_STATUS, data);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
